import { format } from 'date-fns';
import { formatAccountToString, formatAddressDisplay } from './icrcAccount';

// 格式化数字，添加千位分隔符
export const formatNumber = (num: number | string): string => {
  if (num === null || num === undefined || num === '') {
    return '0';
  }
  
  // 如果是字符串，先移除下划线和逗号分隔符
  let cleanedNum = num.toString();
  cleanedNum = cleanedNum.replace(/[_,]/g, '');
  
  // 检查是否是有效的数字字符串
  if (!/^\d+(\.\d+)?$/.test(cleanedNum)) {
    return '0';
  }
  
  // 分离整数部分和小数部分
  const parts = cleanedNum.split('.');
  const integerPart = parts[0];
  const decimalPart = parts[1];
  
  // 从右到左添加千位分隔符
  const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  
  // 如果有小数部分，拼接起来
  return decimalPart !== undefined ? `${formattedInteger}.${decimalPart}` : formattedInteger;
};

// 格式化代币数量（考虑精度）
export const formatTokenAmount = (amount: any, decimals: number): string => {
  // 处理各种可能的输入类型
  let amountStr: string;
  
  if (!amount) {
    return '0';
  }
  
  if (Array.isArray(amount)) {
    // 如果是数组，取第一个元素
    amountStr = amount.length > 0 ? String(amount[0]) : '0';
  } else if (typeof amount === 'object') {
    // 如果是对象，尝试转换为字符串
    amountStr = amount.toString ? amount.toString() : '0';
  } else {
    // 其他情况，转换为字符串
    amountStr = String(amount);
  }
  
  // 移除字符串中的下划线（如果有的话）
  const cleanedAmount = amountStr.replace(/_/g, '');
  
  try {
    const value = BigInt(cleanedAmount);
    const divisor = BigInt(10 ** decimals);
    const integerPart = value / divisor;
    const fractionalPart = value % divisor;
    
    const integerStr = formatNumber(integerPart.toString());
    
    if (fractionalPart === BigInt(0)) {
      return integerStr;
    }
    
    const fractionalStr = fractionalPart.toString().padStart(decimals, '0');
    const trimmedFractional = fractionalStr.replace(/0+$/, '');
    
    return `${integerStr}.${trimmedFractional}`;
  } catch (error) {
    console.error('Error formatting token amount:', error, 'Input:', amount);
    return '0';
  }
};

// 格式化地址，显示前后部分
export const formatAddress = (address: string, startLength: number = 12, endLength: number = 10): string => {
  if (!address) {
    return 'Unknown';
  }

  // 使用新的ICRC账户格式化函数
  return formatAddressDisplay(address, startLength, endLength);
};

// 格式化日期时间
export const formatDateTime = (timestamp: number): string => {
  // 如果时间戳是纳秒级的，转换为毫秒
  const date = timestamp > 1e12 ? new Date(timestamp / 1e6) : new Date(timestamp * 1000);
  return format(date, 'MMM d, yyyy HH:mm');
};



// 将账户对象转换为字符串
// 使用新的ICRC账户格式化函数
export const accountToString = (account: any): string => {
  // 如果账户是字符串，直接使用formatAccountToString处理
  if (typeof account === 'string') {
    return formatAccountToString(account);
  }

  // 如果账户是对象，也使用formatAccountToString处理
  return formatAccountToString(account);
}; 